import { MarketType, EventSortingType, getOddsFormatById, OddsFormatMB } from "../../../common/Foundation";

export const normalOddsFormats = [
  { 
    label: 'Decimal', 
    value: getOddsFormatById(OddsFormatMB.Decimal)
  },
  { 
    label: 'Hong Kong',
    value: getOddsFormatById(OddsFormatMB.HongKong)
  },
  { 
    label: 'Malay', 
    value: getOddsFormatById(OddsFormatMB.Malay)
  },
  { 
    label: 'American', 
    value: getOddsFormatById(OddsFormatMB.American)
  }
];

export const oddsFormatMaxBetPreference = [
  {
    label: 'American',
    value: getOddsFormatById(OddsFormatMB.American)
  }
]

export const indoOddsFormats = [
  {
    label: 'Indonesian',
    value: getOddsFormatById(OddsFormatMB.Indonesian)
  }
];

export const standardOddsFormats = [
  { 
    label: 'Decimal', 
    value: 'Decimal'
  },
  { 
    label: 'American', 
    value: 'American'
  }
];

export const  oddsFormatTooltipText = {
  decimal: {
    label: 'Decimal Odds',
    text: 'preference_tooltip_decimal' 
  },
  hongkong: { 
    label: 'Hong Kong Odds',
    text: 'preference_tooltip_hongkong' 
  },
  malay: { 
    label: 'Malay Odds', 
    text: 'preference_tooltip_malay' 
  },
  american: { 
    label: 'American Odds', 
    text: 'preference_tooltip_american' 
  },
  indonesian: {
    label: 'Indonesian Odds',
    text: 'preference_tooltip_indonesian'
  }
};

export const displayModes = [
  { 
    label: 'Light',
    value: 'LIGHT' 
  },
  { 
    label: 'Dark', 
    value: 'DARK' 
  }
];

export const marketTypes = [
  { 
    label: 'All', 
    value: MarketType.ALL
  },
  { 
    label: '1 line', 
    value: MarketType._1LINE
  },
  { 
    label: '3 lines', 
    value: MarketType._3LINES
  },
  { 
    label: '5 lines',
    value: MarketType._5LINES 
  }
];

export const eventSortingTypes = [
  { 
    label: 'SortByTime', 
    value: EventSortingType.SortByTime 
  },
  { 
    label: 'Sort by default',
    value: EventSortingType.SortByDefault 
  }
];

export const pageTypes = [  
  { 
    label: 'SingleLine', 
    value: 'SINGLE' 
  },
  { 
    label: 'DoubleLine', 
    value: 'DOUBLE'
  }
];
  

export const defaultPages = [
  { 
    label: 'Main Markets',
    value: 'TODAY' 
  },
  { 
    label: 'Moneyline/1x2', 
    value: 'ML_1X2' 
  },
  { 
    label: 'Team Totals', 
    value: 'TEAM_TOTAL'
  }
];

export const confirmTypes = [
  { 
    label: 'Yes', 
    value: true
  },
  { 
    label: 'No', 
    value: false 
  }
];


// WEBPACK FOOTER //
// ./src/app/components/AccountComponent/PreferencesComponent/PreferencesConfiguaration.js